import { Page } from '@dixa/lib-shared-habla';

import { rolesApi } from 'apis/roles';
import { useAppPathParams } from 'utils/url/useAppPathParams';

import { SettingsAgentsRoleForm } from '../../../../components/form/settingsAgentsRoleForm';

export const SettingsAgentsRolesEditPermissionsView = (): JSX.Element => {
  const { roleType, roleId } = useAppPathParams(
    '/settings/agents/roles/:roleType/:roleId/permissions',
  );

  const { roleWithScopes } =
    rolesApi.endpoints.readRoleWithScopes.useQueryState(
      {
        roleId,
        isSystemRole: roleType === 'system',
      },
      {
        selectFromResult: ({ data, ...rest }) => ({
          ...rest,
          roleWithScopes: data?.data,
        }),
      },
    );

  return (
    <>
      <Page.Body>
        <SettingsAgentsRoleForm roleWithScopes={roleWithScopes} />
      </Page.Body>
    </>
  );
};
